import { render, staticRenderFns } from "./UploadFrequencyCheck.vue?vue&type=template&id=57a01c9c&"
import script from "./UploadFrequencyCheck.vue?vue&type=script&lang=js&"
export * from "./UploadFrequencyCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports